import {ValueObject} from '@s-ui/domain'

/**
 * https://schema.org/GeoCoordinates
 */
export class GeoCoordinatesStructuredDataSeoValueObject extends ValueObject {
  #latitude
  #longitude
  #type = 'GeoCoordinates'

  constructor({latitude, longitude}) {
    super()
    this.#latitude = latitude
    this.#longitude = longitude
  }

  static createFromPrimitives({latitude, longitude}) {
    return new GeoCoordinatesStructuredDataSeoValueObject({latitude, longitude})
  }

  get latitude() {
    return this.#latitude
  }

  get longitude() {
    return this.#longitude
  }

  get type() {
    return this.#type
  }

  get value() {
    return {
      '@type': this.#type,
      latitude: this.#latitude,
      longitude: this.#longitude
    }
  }
}
